export const FETCH_CONSULT_PACKAGES = 'FETCH_CONSULT_PACKAGES';
